import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LowercaseButton from "../../../components/LowercaseButton/LowercaseButton";
import React, { useState } from "react";
import ParentRoleDialog from "../ParentRoleDialog/ParentRoleDialog";
import { ParentRole } from "../Models/ParentRole";
import {
  DELETE,
  EDIT,
  PARENT_ROLE_DELETE,
  PARENT_ROLE_DELETE_CONFIRMATION,
  PARENT_ROLE_EDIT,
} from "../../../utility/TextLabels";
import ConfirmationDialog from "../../../components/ConfirmationDialog/ConfirmationDialog";

interface ParentRoleItemProps {
  name: string;
  id?: string;
  onUpdateParentRole: (parentRole: ParentRole) => void;
  onDeleteParentRole: (id: string) => void;
}

const ParentRoleItem: React.FC<ParentRoleItemProps> = ({
  name,
  id,
  onUpdateParentRole,
  onDeleteParentRole,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 1,
        paddingLeft: 2,
        paddingRight: 3,
        paddingTop: 1,
      }}
    >
      <Box>
        <Typography
          variant="h6"
          fontFamily="Lato"
          fontSize="16px"
          fontStyle="normal"
          fontWeight={400}
          lineHeight="normal"
        >
          {name}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: "1em",
          alignItems: "flex-end",
        }}
      >
        <LowercaseButton color="primary" onClick={() => setIsOpen(true)}>
          {EDIT}
        </LowercaseButton>
        <ParentRoleDialog
          title={PARENT_ROLE_EDIT}
          existingId={id}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmit={onUpdateParentRole}
        />
        <LowercaseButton
          color="secondary"
          onClick={() => setIsConfirmationOpen(true)}
        >
          {DELETE}
        </LowercaseButton>
        <ConfirmationDialog
          title={PARENT_ROLE_DELETE}
          text={PARENT_ROLE_DELETE_CONFIRMATION}
          isOpen={isConfirmationOpen}
          onClose={() => setIsConfirmationOpen(false)}
          onSubmit={() => onDeleteParentRole(id!)}
        />
      </Box>
    </Box>
  );
};

export default ParentRoleItem;
